import React, { useCallback, useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../contexts/AuthContext";
import { claveWizard, COPY_WIZARD as T, PASOS, wizardActivo } from "../lib/wizard";

export function Senales({ datos, permitidos = PASOS }) {
  return <ul className="grid gap-2 sm:grid-cols-3" aria-label={T.titulo}>
    {permitidos.map(p => <li key={p.id} className="rounded-lg border border-slate-200 p-3">
      <span>{p.label}</span>{" · "}<span data-testid={`senal-${p.id}`}>
        {datos?.pasos?.[p.id] === true ? T.hecho : T.pendiente}
        {datos?.pasos?.[p.id] === null ? " —" : ""}
      </span>
    </li>)}
  </ul>;
}

// `ocultarSiCompleto` (Dashboard, 25 Oct): con todas las señales reales completas la tarjeta
// desaparece del tablero; en Mi plan se sigue mostrando con el mensaje final.
export function PrimerosPasos({ ocultarSiCompleto = false }) {
  const { user, puede } = useAuth();
  const [datos, setDatos] = useState(null);
  const [fallo, setFallo] = useState(false);
  const activo = wizardActivo(user) && puede("configuracion");
  const cid = user?.active_clinic_id;
  const cargar = useCallback(async () => {
    if (!activo || !cid) return;
    try { const { data } = await api.get("/primeros-pasos"); setDatos(data); setFallo(false); }
    catch { setDatos(null); setFallo(true); }
  }, [activo, cid]);
  useEffect(() => {
    setDatos(null); cargar();
    window.addEventListener("focus", cargar);
    return () => window.removeEventListener("focus", cargar);
  }, [cargar]);
  if (!activo) return null;
  if (ocultarSiCompleto && datos?.completo === true) return null;
  return <section className="bg-white rounded-2xl border p-5 space-y-4" data-testid="primeros-pasos">
    <h2 className="font-bold text-xl">Primeros pasos</h2>
    {fallo ? <p role="alert">{T.pendiente} <button onClick={cargar}>{T.retomar}</button></p> :
      <Senales datos={datos} permitidos={PASOS.filter(p => puede(p.cap))} />}
    {datos?.completo && <p role="status">{T.final}</p>}
    <Link className="inline-block text-blue-700 underline" to="/app/configurar">{T.retomar}</Link>
  </section>;
}

// Se monta antes del guardia PA-3 para que el administrador en espera pueda
// configurar desde su primer ingreso al panel. Apagada: cero peticiones/storage.
export function WizardEntrada() {
  const { user, puede } = useAuth();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const activo = wizardActivo(user) && user?.role === "admin" && puede("agenda") && puede("configuracion");
  const clave = claveWizard(user, "visto");
  useEffect(() => {
    if (!activo || !pathname.startsWith("/app") || pathname === "/app/configurar" || pathname === "/app/cambiar-password") return;
    if (localStorage.getItem(clave)) return;
    let vivo = true;
    api.get("/primeros-pasos").then(({ data }) => {
      if (!vivo || typeof data?.pasos?.medicos !== "boolean") return;
      localStorage.setItem(clave, "1");
      if (data.pasos.medicos === false) navigate("/app/configurar", { replace: true });
    }).catch(() => {});
    return () => { vivo = false; };
  }, [activo, pathname, clave, navigate]);
  return null;
}
